export default __webpack_public_path__ + "static/media/product_11.19d2ed7f.png";